export default __webpack_public_path__ + "2bcc1788e64ae440e41d2242afbdbf2e.jpg";